import { DbCommon } from "../constants/dbCommon";

export class AccountsList {
    accounts: AccountModel[];

    constructor() {
        this.accounts = new Array<AccountModel>();
    }
}

export class AccountModel {
    accountID: number;
    accountDescription: string;

    constructor() {
        this.accountID = 0;
        this.accountDescription = null;
    }
}

export class AccountDetail {
    totalDeposits: number;
    totalPayments: number;
    accountBalance: number;
    accountIDUsed: number;
    dateRangeDropDownEnumUsed: number;
    memberAccountDetails: AccountDetailModel[];

    constructor() {
        this.totalDeposits = 0;
        this.totalPayments = 0;
        this.accountBalance = 0;
        this.accountIDUsed = 0;
        this.dateRangeDropDownEnumUsed = 0;
        this.memberAccountDetails = new Array<AccountDetailModel>();
    }
}

export class AccountDetailModel {
    dateToUse: string;
    transaction: string;
    amount: number;
    billingPeriodDisplay: string;
    benefitName: string;
    payrollCode: string;

    constructor() {
        this.dateToUse = null;
        this.transaction = null;
        this.amount = null;
        this.billingPeriodDisplay = null;
        this.benefitName = null;
        this.payrollCode = null;
    }
}



export class AccountFilterPayload {
    accountID: number;
    dateRangeDropDownEnum: number;

    constructor() {
        this.accountID = DbCommon.emptyInt;
        this.dateRangeDropDownEnum = 0;
    }
}